// rv-view-switcher: loaded by RV – Collection when the view switcher is on.
// Buttons [data-rv-grid] set 1–2 columns (mobile) or 2–4 columns (desktop); the choice is kept
// in localStorage and applied as html[data-rv-grid-m] / html[data-rv-grid-d].

const root = document.documentElement;

function currentValue(scope) {
  if (scope === 'm') return root.dataset.rvGridM || '2';
  return root.dataset.rvGridD || document.querySelector('[data-rv-default-grid-d]')?.dataset.rvDefaultGridD || '4';
}

function sync() {
  document.querySelectorAll('[data-rv-grid]').forEach((button) => {
    button.setAttribute('aria-pressed', String(button.dataset.rvGrid === currentValue(button.dataset.rvGridScope)));
  });
  // Keep card images sharp: tell the browser how wide cards now are
  const mobile = currentValue('m') === '1' ? '100vw' : '50vw';
  const desktop = Math.ceil(100 / Number(currentValue('d'))) + 'vw';
  document.querySelectorAll('.rv-collection__grid .rv-card__image').forEach((image) => {
    image.sizes = `(min-width: 990px) ${desktop}, (min-width: 750px) 33vw, ${mobile}`;
  });
}

document.addEventListener('click', (event) => {
  const button = event.target.closest?.('[data-rv-grid]');
  if (!button) return;
  const key = button.dataset.rvGridScope === 'm' ? 'rvGridM' : 'rvGridD';
  root.dataset[key] = button.dataset.rvGrid;
  try {
    localStorage.setItem(button.dataset.rvGridScope === 'm' ? 'rv-grid-m' : 'rv-grid-d', button.dataset.rvGrid);
  } catch (error) {}
  sync();
});

// The filter bar is re-rendered when filters change; keep the pressed state in step
new MutationObserver(() => {
  clearTimeout(window.rvViewSyncTimer);
  window.rvViewSyncTimer = setTimeout(sync, 50);
}).observe(document.querySelector('.rv-collection') || document.body, { childList: true, subtree: true });

sync();
